// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";

import { Backdrop } from "@mui/material";

import image_url from "../../assets/images/image_url";

const BackdropComponent = () => {
  const backdropRef = useRef(null);
  const [dimension, setDimension] = useState(backdropRef.current);
  // let height, width;

  useEffect(() => {
    const height = backdropRef.current?.getBoundingClientRect()?.height;
    const width = backdropRef.current?.getBoundingClientRect()?.width;
    const dimension = Math.min(height / 2, width / 2);
    setDimension(dimension);
  }, [backdropRef]);

  // useEffect(() => {
  //   const dimension = Math.min(height / 2, width / 2);
  //   setDimension(dimension);
  // }, [height, width]);

  return (
    <Backdrop
      ref={backdropRef}
      style={{
        opacity: 0.5,
        visibility: "visible",
        width: "100vw", // Full viewport width
        height: "100vh", // Full viewport height
      }}
      sx={{
        color: "#fff",
        position: "fixed", // Ensure it covers the entire screen
        top: 0,
        left: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <img
        src={image_url.LOADER_MCHI_GIF}
        width={dimension}
        height={dimension}
      />
    </Backdrop>
  );
};

export default BackdropComponent;
